/* eslint-disable react/destructuring-assignment */
import clsx from 'clsx';
import { FC } from 'react';

import AnimatedButton, { AnimatedButtonProps } from '@/components/shared/AnimatedButton';

import css from './style.module.scss';

const AnimatedSubmitButton: FC<AnimatedButtonProps> = props => (
	<AnimatedButton
		{...props}
		className={clsx(css.submitButton, props.className)}
		classNameText={clsx(css.submitLabel, props.classNameText)}
	>
		{props.children}
	</AnimatedButton>
);

export default AnimatedSubmitButton;
